import React, { Fragment, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { findOne, getfile } from "../../../../services/Document__Servive";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import PdfRender from "../../../PdfRender/PdfRender";
import { getMoisString } from "../../../../services/Constante";

const FormDocument = ({ documentId = 0 }) => {
  const notify = useContext(notifyContext);
  const [isLoading, setIsLoading] = useState(true);
  const [doc, setDoc] = useState(null);
  const nav = useContext(navContext);
  const paramsRoute = useParams();
  const [id, setId] = useState(documentId !== 0 ? documentId : paramsRoute.id);

  useEffect(() => {
    fetchOneDocument(id);
  }, []);

  useEffect(() => {
    nav({
      links: [
        {
          href: "",
          linkname: "Bulletins de	paie",
        },
      ],
      children: "",
    });
  }, []);

  const fetchOneDocument = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setDoc({ ...response.data });
        fecthFile(response.data.chemin);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fecthFile = async (filename) => {
    getfile(filename)
      .then((response) => {
        setSelectedFile(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /* FILE HANDLE */
  const [selectedFile, setSelectedFile] = useState(); // contient des informations sur le fichier actuellement sélectionné.
  /* FILE HANDLE END */

  return (
    <Fragment>
      {doc && (
        <>
          <form className="form">
            <div className="form-header">
              <div className="doc__info">
                <p className="create_at">
                  Créé le :{" "}
                  <span>
                    {" "}
                    {new Date(doc.create_at).toLocaleDateString("fr-FR")}
                  </span>{" "}
                  à<span> {new Date(doc.create_at).toLocaleTimeString()}</span>
                </p>
                <p className="last_modified">
                  {" Dernière modification le : "}
                  <span>
                    {" "}
                    {new Date(doc.last_modified).toLocaleDateString("fr-FR")}
                  </span>{" "}
                  à
                  <span>
                    {" "}
                    {new Date(doc.last_modified).toLocaleTimeString()}
                  </span>
                </p>
              </div>
            </div>

            <div className="form-body">
              <div className="form-group">
                <label htmlFor="mois" className="form-label">
                  Mois :
                </label>
                <div>{getMoisString(doc.mois)}</div>
              </div>

              <div className="form-group">
                <label htmlFor="annee" className="form-label">
                  Année :
                </label>
                <div>{doc.annee}</div>
              </div>
            </div>
          </form>
          {selectedFile && (
            <div
              className="preview-pdf"
              style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
              }}
            >
              <PdfRender file={selectedFile} />
            </div>
          )}
        </>
      )}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormDocument;
